import React from 'react';
export default function AdminNavigation({
  mainTabs,
  groupsSubTabs,
  therapySubTabs,
  activeTab,
  activeSubTab,
  onMain,
  onSub
}) {
  return <nav className="admin-navigation" aria-label="Разделы администрирования">
                <div className="admin-main-navigation">{mainTabs.map(tab => {
        const Icon = tab.icon;
        return <button key={tab.id} className={activeTab === tab.id ? 'active' : ''} aria-current={activeTab === tab.id ? 'page' : undefined} onClick={() => onMain(tab.id)}><Icon size={18} /><span>{tab.label}</span></button>;
      })}</div>
                {['groupsSection', 'therapySection'].includes(activeTab) && <div className="admin-sub-navigation">{(activeTab === 'groupsSection' ? groupsSubTabs : therapySubTabs).map(tab => {
        const Icon = tab.icon;
        return <button key={tab.id} className={activeSubTab === tab.id ? 'active' : ''} aria-current={activeSubTab === tab.id ? 'page' : undefined} onClick={() => onSub(tab.id)}><Icon size={16} />{tab.label}</button>;
      })}</div>}
            </nav>;
}
